import { putMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';

// Action Creators
export const getProfileSectionUpdate = () => ({
  type: UPDATE_PROFILE,
});

export const getProfileSectionUpdateSuccess = (users) => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: users,
});

export const getProfileSectionUpdateFailure = (error) => ({
  type: UPDATE_PROFILE_FAILURE,
  payload: error,
});

// Thunk Function
export const updateProfileSectionData = (external, body) => {
  return async (dispatch) => {
    dispatch(getProfileSectionUpdate());
    try {
      const response = await putMethodWithToken(
        url?.doctorProfileSection + external?.providerId + '/',
        body
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getProfileSectionUpdateSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(getProfileSectionUpdateFailure('error?.message'));
      }
    } catch (error) {
      dispatch(getProfileSectionUpdateFailure(error?.message));
    }
  };
};
